// extracted by mini-css-extract-plugin
export default {"loader-container":"PageLoading_loader-container__hbKwj"};